{
    "Profile_SupernovaCommercial_Memberships.header": "Adhésions",
    "Profile_SupernovaCommercial_Memberships.membershipInformation": "Informations d'adhésion",
    "Profile_SupernovaCommercial_Memberships.membershipId": "Numéro de membre Affaires de la CAA"
}
